module.exports = __webpack_public_path__ + "img/titre_lightmode.949abea2.png";